import { opt } from '../lib/media';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, ArrowUpRight, ShoppingBag } from 'lucide-react';
import api from '../api';

export default function InstagramFeed() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/instagram/posts', { params: { limit: 6 } })
      .then((r) => setData(r.data))
      .catch(() => setData({ configured: false, posts: [] }));
  }, []);

  if (!data || !data.configured || !data.posts?.length) return null;

  return (
    <section data-testid="instagram-feed" className="py-20 md:py-28 bg-cream/40">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-gold-dark tracking-luxe text-xs uppercase mb-2 flex items-center justify-center gap-2">
            <Instagram size={14} /> @{data.username}
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-burgundy-900">Follow Us On Instagram</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {data.posts.map((p, idx) => {
            const shoppable = !!p.product_id;
            const linkProps = shoppable
              ? { to: `/product/${p.product_id}` }
              : { href: p.permalink, target: '_blank', rel: 'noreferrer' };
            const Tag = shoppable ? Link : 'a';
            return (
              <Tag key={p.id} {...linkProps} data-testid={`instagram-post-${idx}`}
                 className="group img-zoom relative aspect-square overflow-hidden fade-up" style={{ animationDelay: `${idx * 0.06}s` }}>
                <img src={opt(p.image, 400)} alt={p.caption ? p.caption.slice(0, 80) : 'Hitera on Instagram'} loading="lazy" decoding="async" width="400" height="400" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-burgundy-950/0 group-hover:bg-burgundy-950/45 transition-colors flex items-center justify-center">
                  {shoppable
                    ? <span className="opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1.5 bg-cream/95 text-burgundy-950 text-[10px] tracking-wideluxe uppercase px-3 py-1.5"><ShoppingBag size={13} /> Shop</span>
                    : <Instagram className="text-cream opacity-0 group-hover:opacity-100 transition-opacity" size={26} />}
                </div>
              </Tag>
            );
          })}
        </div>
        <div className="text-center mt-10">
          <a href={`https://www.instagram.com/${data.username}`} target="_blank" rel="noreferrer" data-testid="instagram-follow-link"
             className="inline-flex items-center gap-3 border-b border-gold text-burgundy-900 pb-1 text-xs tracking-wideluxe uppercase hover:text-gold-dark transition-colors">
            Follow @{data.username} <ArrowUpRight size={15} />
          </a>
        </div>
      </div>
    </section>
  );
}
